/**
 * Location Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {string}
 */
window.locationFormatter = function(value, row) {
    let html = '';
    switch (row.type) {
        case 'Dry Container':
            if (rights.includes("ships.show")) {
                html = '<a href="/ships/show/'+row.ship_id+'">'+value+'</a>';
            } else if (value) {
                html = value;
            }
            break;
        case 'Reefer':
            if (rights.includes("ships.show")) {
                html = '<a href="/ships/show/'+row.ship_id+'">'+value+'</a>';
            } else if (value) {
                html = value;
            }
            break;
        case 'Terminal':
            html = value;
            break;
        case 'Vehicle':
            if (rights.includes("vehicles.show")) {
                html = '<a href="/vehicles/show/'+row.vehicle_id+'">'+value+'</a>';
            } else if (value) {
                html = value;
            }
            break;
    }
    return html;
};
